export const testimonialDescription =
    'Over the past couple of years I’ve tested different platforms, gathered client feedback, and experimented with different ways to deliver my coaching. After all of that, I’ve come full circle and realized TrainHeroic is still the best platform for delivering high-quality training and coaching.';

export const testimonialAuthor = 'Ruben Cadet: Kettlebell Coach and Firefighter';
